<template>
  <b-row class="base-row-padded">
    <b-col>
      <h2>Devices</h2>
      <DevicePagination :perPage="20" :showSearch="true" :queryStructure="queryStructure"
        :pollingInterval="!pickerMode ? pollingInterval : null" @items-updated="itemsUpdated"
        ref="paginationComponent" />
      <b-row>
        <!-- <b-col xs="10" class="mx-1 mb-2" align="start">
          <b-form inline>
            <b-form-select v-model="queryStructure.custom.status" @change="statusChanged">
              <option :value="null">Filter by publish status</option>
              <option v-for="(value, $index) in publishStatus" :value="$index" :key="$index">{{value}}</option>
            </b-form-select>
          </b-form>
        </b-col> -->
        <b-col xs="2" class="mx-1 mb-2" align="start" v-if="!pickerMode">
          <b-button variant="light" @click="downloadExcel">Export to Excel</b-button>
        </b-col>
        <b-col xs="2" class="mb-2" align="end" v-if="!pickerMode">
          <b-button variant="success" @click="createDevice" style="float: right;">New Device</b-button>
          <b-button variant="success" class="mr-2" @click="createCheckout" style="float: right;">New Checkout</b-button>
        </b-col>
        <b-col xs="2" class="mx-1 mb-2" align="start" v-if="pickerMode">
          <b-button variant="success" @click="selectAll" v-if="!isAllSelected"
            title="Selects all new devices to add to the list">Select all</b-button>
          <b-button variant="warning" @click="deselectAll" v-if="isAllSelected"
            title="Delects all newly selected devices">Deselect all</b-button>
        </b-col>
      </b-row>

      <b-row>
        <b-table :fields="fields" :items="devicesArray" :busy="devicesArray === null" @row-clicked="showDevice"
          :striped="true" :small="true" :hover="true" :responsive="true" :tbody-tr-class="rowClassFilter"
          :stacked="'lg'" :no-local-sorting="true" :no-sort-reset="true" :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc" @sort-changed="sortingChanged">

          <template slot="name" slot-scope="data">
            {{ data.item.name }}
          </template>

          <template slot="activation_code" slot-scope="data">
            {{ data.item.activation_code }}
          </template>

          <template slot="pmi_code" slot-scope="data">
            {{ data.item.pmi_code }}
          </template>

          <template slot="pos_code" slot-scope="data">
            {{ data.item.pos_code }}
          </template>

          <template slot="address" slot-scope="data">
            {{ data.item.address }}
          </template>

          <template slot="city" slot-scope="data">
            {{ data.item.city }}
          </template>

          <template slot="position" slot-scope="data">
            {{ data.item.position }}
          </template>

          <template slot="group.name" slot-scope="data">
            {{ data.item.group.name }}
          </template>

          <template #cell(playlistName)="data">
            {{ getPlaylistName(data) }}
          </template>

          <template #cell(print)="data">
            {{ data.item.print ? 'Yes' : 'No' }}
          </template>

          <template #cell(version)="data">
            {{ data.item.version || '-' }}
          </template>

          <template #cell(version_updated_at)="data">
            {{ parseDate(data.item.version_updated_at) }}
          </template>

          <template #cell(last_seen)="data">
            {{ parseDate(data.item.last_seen) }}
          </template>
          <template #cell(id)="data" v-if="!pickerMode">
            <b-button class="m-1" variant="primary" size="sm" @click.prevent="showDevice(data.item.id)">Edit</b-button>
            <b-button class="m-1" variant="warning" size="sm" v-if="isRemoteAccess(data.item.type)"
              @click.prevent="remoteAccess(data.item.remote_url)">Remote</b-button>
            <b-button class="m-1" variant="danger" size="sm"
              @click.prevent="deleteDeviceProxy(data.item)">Delete</b-button>
          </template>
        </b-table>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import formsMixin from '@/mixins/forms';
import dateTimeMixin from '@/mixins/datetime';
import devicesMixin from '@/views/admin/devices/devicesMixin';
import DevicePagination from './pagination/DevicePagination.vue';


export default {
  components: { DevicePagination },
  mixins: [formsMixin, devicesMixin, dateTimeMixin],
  props: {
    pickerMode: {
      type: [Boolean],
      required: false,
      default: false,
    },
    filterArray: {
      type: [Array],
      required: false,
    },
  },
  data() {
    return {
      sortBy: 'last_seen',
      sortDesc: false,
      devicesArray: null,
      isAllSelected: false,
      queryStructure: {
        pagePropName: 'page',
        perPagePropName: 'per_page',
        searchPropName: 'search',
        typeFilterPropName: 'type',
        tagFilterPropName: 'rrp_pos_type',
        tierFilterPropName: 'tier',
        channelFilterPropName: 'channel',
        orientationFilterPropName: 'orientation',
        positionFilterPropName: 'position',
        printFilterPropName: 'print',
        unassignedDevicesFilterPropName: 'unassigned_devices_only',
        responseDataKey: 'devices',
        custom: {
          status: null,
          order_by: [
            'last_seen',
            'desc',
          ],
        },
      },
      fields: [
        { key: 'name', label: 'Name', sortable: true },
        { key: 'activation_code', label: 'Act. code', sortable: true },
        { key: 'pmi_code', label: 'PMI Code', sortable: true },
        { key: 'pos_code', label: 'POS Code', sortable: true },
        { key: 'address', label: 'Address', sortable: true },
        { key: 'city', label: 'City', sortable: true },
        { key: 'position', label: 'Position', sortable: true },
        { key: 'group.name', label: 'Group', sortable: true },
        { key: 'playlistName', label: 'Playlist', sortable: true },
        { key: 'type_text', label: 'Type', sortable: true },
        { key: 'print', label: 'Print', sortable: true },
        { key: 'version', label: 'Version', sortable: true },
        { key: 'version_updated_at', label: 'Updated', sortable: true },
        { key: 'last_seen', label: 'Last Seen', sortable: true },
        // eslint-disable-next-line object-curly-newline
        { key: 'id', label: 'Options', tdClass: 'td-no-wrap', sortable: false },
      ],
      pollingInterval: 100,
    };
  },
  methods: {
    isRemoteAccess(type) {
      return type === 2;
    },
    remoteAccess(url) {
      window.open(url, '_blank');
    },
    itemsUpdated(data) {
      this.devicesArray = data;
      if (this.devicesArray) {
        this.devicesArray.forEach((e, idx) => {
          // eslint-disable-next-line no-underscore-dangle
          this.devicesArray[idx]._rowVariant = e && !this.pickerMode ? e.alert : '';
        });
      }
    },
    deleteDeviceProxy(device) {
      this.deleteDevice(device).then(() => {
        this.$refs.paginationComponent.pageChanged();
      }).catch(() => { });
    },
    statusChanged() {
      this.$refs.paginationComponent.pageChanged(1);
    },
    showDevice(target) {
      // click in picker mode
      if (this.pickerMode) {
        this.$emit('item-clicked', target);
        return;
      }
      let finalTarget = null;

      if (typeof target === 'number') {
        finalTarget = target;
      } else if (target && target.id) {
        finalTarget = target.id;
      }
      this.$router.push({ name: 'showDevice', params: { id: finalTarget } });
    },
    createDevice() {
      this.$router.push({ name: 'showDevice', params: { id: 'new' } });
    },
    createCheckout() {
      this.$router.push({ name: 'showDevice', params: { id: 'new', checkout: true } });
    },
    rowClassFilter(item) {
      if (this.pickerMode && this.filterArray) {
        const found = this.filterArray.find(e => e.id === item.id);
        if (found) {
          if (found.unavailable) {
            return 'bg-warning';
          }
          return 'bg-secondary';
        }
      }
      return '';
    },
    sortingChanged(ctx) {
      this.queryStructure.custom.order_by[0] = ctx.sortBy;
      this.queryStructure.custom.order_by[1] = ctx.sortDesc ? 'asc' : 'desc';
      this.$refs.paginationComponent.pageChanged();
    },
    getPlaylistName(data) {
      if (data.item.playlist && data.item.playlist.name.length) return data.item.playlist.name;
      if (data.item.loop_playlist && data.item.loop_playlist.name.length) return data.item.loop_playlist.name;
      if (data.item.weekly_playlist && data.item.weekly_playlist.name.length) return data.item.weekly_playlist.name;
      return '';
    },
    deselectAll() {
      this.$emit('deselect-all');
      this.isAllSelected = false;
    },
    selectAll() {
      const filter = this.$refs.paginationComponent.filters;
      filter[this.queryStructure.perPagePropName] = 'all';
      this.getFilteredDeviceProxy(filter).then((filteredDevices) => {
        filteredDevices.forEach((e) => {
          this.$emit('item-clicked', e, true);
        });
        this.isAllSelected = true;
      });
    },
    getFilteredDeviceProxy(filter) {
      return this.getFilteredDevices(filter)
        .then(res => res.data)
        .catch(() => { });
    },
  },
};
</script>

<style lang="less">
tr.bg-secondary {
  td {
    color: white;
  }
}
</style>
